import { FormattingRule } from "./formattingRule"

export enum CalculationType {
	Total,
	Average,
	Min,
	Max,
	Count,
	CountPerDay
}

export enum CalculationSortItemType {
	Calculation,
	CalculationTotal,
	IncludedCalculation
}

export interface InsightCalculation {
	id?: number;
	key: string;
	hidden?: boolean | null
	fieldId: string;
	calcType?: CalculationType | null;
	label: string;
	formattingRules: FormattingRule[];
	value?: number;
	groupBy?: string | null;
	groupByExtended?: string | null;
	field?: string;
	expression?: string | null;
	applyFilters?: boolean
	calculatePercentage?: boolean

	groupByKeyLabels?: { [key:string]: string }
	timeSpentCalculation?: TimeSpentCalculation;
}

export interface InsightCalculationTotal {
	key: string;
	title: string;
	hidden?: boolean | null
	calculationList?: string[];
	subtractCalculationList?: string[];
	value?: number;
	groupBy?: string | null;
	formattingRules?: FormattingRule[];
	expression: string | null;
	expressionCalculationList?: string[];

	collate: boolean
	collateInclude?: { id: string, label: string }[] | null
	collateExclude?: { id: string, label: string }[] | null
}

export interface TimeSpentCalculation {
	trackingFieldId: string;
	searchLabel: string | null;
	searchValue: string | null;
}

export interface InsightCalculationItem<T> {
	key: string
	label?: string
	hidden?: boolean | null
	type: CalculationSortItemType
	item: T
	settings: any
}

export interface InsightCalculationColumn {
	key: string
	title: string
	expression?: string | null;
}

export type InsightCalculationResult = number | { [name: string]: number }
